import Reveal from "@/components/Reveal";

const CHAPTERS = [
  {
    num: "01",
    title: "Temperature integrity",
    body: "A degree lost is a product lost. Every vehicle in our fleet holds its setpoint with continuous data-logged refrigeration, so what leaves your dock arrives in the exact state it left.",
  },
  {
    num: "02",
    title: "Speed without thaw",
    body: "Fast is worthless if the chain breaks. Our metro runs are routed live around Sydney traffic, keeping transit times tight without ever cracking a door open at the wrong moment.",
  },
  {
    num: "03",
    title: "Sydney, street by street",
    body: "From Eastern Creek warehouses to Potts Point kitchens, we know the loading docks, the laneways and the last-kilometre traps of this city better than anyone else on the road.",
  },
];

const Manifesto = () => (
  <section id="manifesto" data-testid="manifesto-section" className="relative py-32 lg:py-40">
    <div className="max-w-[1440px] mx-auto px-6 lg:px-12">
      <Reveal>
        <p className="font-mono text-xs uppercase tracking-[0.25em] text-frost font-bold mb-6 flex items-center gap-3">
          <span className="w-8 h-px bg-frost inline-block" />
          The manifesto
        </p>
        <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl tracking-tight uppercase font-medium max-w-3xl">
          Why the cold chain is sacred
        </h2>
      </Reveal>

      <div className="mt-20 grid lg:grid-cols-3 gap-px bg-white/10 border border-white/10">
        {CHAPTERS.map((ch, i) => (
          <Reveal key={ch.num} delay={i * 0.12} className="bg-abyss">
            <article
              data-testid={`manifesto-chapter-${ch.num}`}
              className="group p-10 lg:p-12 h-full hover:bg-surface transition-colors duration-500"
            >
              <span className="font-mono text-sm text-frost font-bold">{ch.num}</span>
              <h3 className="font-display text-2xl lg:text-3xl font-medium mt-6 tracking-tight group-hover:text-ice transition-colors duration-500">
                {ch.title}
              </h3>
              <p className="mt-6 text-mist font-light leading-relaxed">{ch.body}</p>
            </article>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);

export default Manifesto;
